import { useState} from 'react';
import React, { useEffect } from 'react';
import "../payment_success.css";  // reuse the same styles if applicable
import UserStatus from './UserStatus';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';

const PaymentFail = () => {
  useEffect(() => {
    document.title = "Payment Failed | TradeBarta.com";
  }, []);

  const [searchParams] = useSearchParams();
  const invoiceNumber = searchParams.get('invoice'); // match your backend param
  const navigate = useNavigate();
const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth >= 769);
  
useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 769) {
        setSidebarOpen(true);  // open sidebar on desktop
      } else {
        setSidebarOpen(false); // closed on mobile
      }
    };

    handleResize(); // run on mount

    // Optional: listen for window resize to update sidebar automatically
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };
    
  useEffect(() => {
    if (!invoiceNumber) {
      // Redirect if no invoice number provided
      navigate('/dashboard');
    }
  }, [invoiceNumber, navigate]);

  return (
<div className='dashboard-wrapper'>
          {/* Top Navigation Bar */}
      <header className="header-container">
  <a href="/" className="logo">
    <img src={require("../images/logo.png")} alt="Logo" />
  </a>       
                    <button className="menu-toggle" onClick={toggleSidebar}>☰</button>  
     <UserStatus />
          </header>       
      {/* Sidebar and Main Content */}
                    
   <div className={`dashboard-container ${sidebarOpen ? 'sidebar-open' : ''}`}>
  
     <aside className={`sidebar ${sidebarOpen ? 'show-sidebar' : ''}`}>
        <ul>
          <li><a href="/dashboard">Dashboard</a></li>
          <li><a href="/payment_history">Billing and Payment History</a></li>
          <li><a href="/referral_dashboard">Refer & Win</a></li>
          <li><a href="/profile">My Profile</a></li>
          <li><a href="/contact_us">Support</a></li>
        </ul>
        </aside>
        <main className="main-content">
          <section className="data-table">
            <div className="fail-container" style={{ textAlign: 'center', padding: '20px' }}>
              <h4>❌ Your payment failed</h4>
              <p>Invoice Number: <strong>{invoiceNumber}</strong></p>
              <p>Please try again or contact support if the issue persists.</p>
              <Link to="/payment_page" className="dashboard-button" style={{ backgroundColor: '#b52a2a', color: '#fff', padding: '10px 20px', borderRadius: '4px', textDecoration: 'none', display: 'inline-block' }}>
                Retry Payment
              </Link>
              <br />
              <Link to="/dashboard" style={{ marginTop: '10px', display: 'inline-block' }}>
                Go to Dashboard
              </Link>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default PaymentFail;